"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecreaseAnyProduction = void 0;
var Resources_1 = require("../Resources");
var SelectPlayer_1 = require("../inputs/SelectPlayer");
var DeferredAction_1 = require("./DeferredAction");
var DecreaseAnyProduction = (function () {
    function DecreaseAnyProduction(player, resource, count, title) {
        if (count === void 0) { count = 1; }
        if (title === void 0) { title = 'Select player to decrease ' + resource + ' production by ' + count + ' step(s)'; }
        this.player = player;
        this.resource = resource;
        this.count = count;
        this.title = title;
        this.priority = DeferredAction_1.Priority.ATTACK_OPPONENT;
    }
    DecreaseAnyProduction.prototype.execute = function () {
        var _this = this;
        if (this.player.game.isSoloMode())
            return undefined;
        var candidates = [];
        if (this.resource === Resources_1.Resources.MEGACREDITS) {
            candidates = this.player.game.getPlayers().filter(function (p) { return p.getProduction(_this.resource) >= _this.count - 5; });
        }
        else {
            candidates = this.player.game.getPlayers().filter(function (p) { return p.getProduction(_this.resource) >= _this.count; });
        }
        if (this.resource === Resources_1.Resources.STEEL || this.resource === Resources_1.Resources.TITANIUM) {
            candidates = candidates.filter(function (candidate) { return !candidate.alloysAreProtected(); });
        }
        if (candidates.length === 0) {
            return undefined;
        }
        if (candidates.length === 1) {
            candidates[0].addProduction(this.resource, -this.count, { log: true, from: this.player });
            return undefined;
        }
        return new SelectPlayer_1.SelectPlayer(candidates, this.title, 'Decrease', function (found) {
            found.addProduction(_this.resource, -_this.count, { log: true, from: _this.player });
            return undefined;
        });
    };
    return DecreaseAnyProduction;
}());
exports.DecreaseAnyProduction = DecreaseAnyProduction;
//# sourceMappingURL=DecreaseAnyProduction.js.map